import { GraphQLResult } from "@aws-amplify/api-graphql";
import { generateClient } from "aws-amplify/api";
import { Observable } from "zen-observable-ts";

const client = generateClient();

export const graphqlOperation = async <
  TResult = unknown,
  TInput = Record<string, unknown>,
>(
  operation: string,
  variables?: TInput
) => {
  return client.graphql({
    query: operation,
    variables,
  }) as unknown as Promise<GraphQLResult<TResult>>;
};

interface ObserverValue<TValue> {
  provider: unknown;
  value: { data: TValue };
}

export const graphqlSubscription = <
  TResult = undefined,
  TInput = Record<string, unknown>,
>(
  operation: string,
  variables?: TInput
) => {
  return client.graphql({
    query: operation,
    variables,
  }) as unknown as Observable<ObserverValue<TResult>>;
};
